import React, { useMemo } from 'react'
import { Bar } from 'react-chartjs-2'
import ChartBase from '@core/components/charts/chart-base'
import { useTrikosPerCity } from '@services/jarvis/hooks'

const TrikosPerCity: React.FC = () => {
    const { data, loading } = useTrikosPerCity()

    const dataSetBuilt = useMemo(() => {
        if (!data) return []

        return data.reduce(
            (currentSet, currentItem: any) => {
                currentSet.labels.push(currentItem.city)
                currentSet.data.push(currentItem.total)
                return currentSet
            },
            { labels: [], data: [] } as { labels: any[]; data: any[] }
        )
        // return data.reduce(
        //     (currentSet, currentItem: any) => {
        //         currentSet.data.push(currentItem.total)
        //         currentSet.labels.push(currentItem.workflow)
        //         return currentSet
        //     },
        //     {
        //         borders: [],
        //         colors: [],
        //         labels: [],
        //         data: []
        //     } as { colors: string[]; labels: string[]; data: number[]; borders: string[] }
        // )
    }, [data])
    return (
        <ChartBase title="Top 10: Trikos por ciudad" loading={loading}>
            <div style={{ height: 260 }}>
                <Bar
                    datasetIdKey="id"
                    options={{
                        plugins: { legend: { position: 'bottom', display: false } },
                        maintainAspectRatio: false
                    }}
                    data={{
                        labels: dataSetBuilt.labels,
                        datasets: [
                            {
                                label: 'Trikos',
                                data: dataSetBuilt.data,
                                backgroundColor: '#ef6c008f'
                            }
                        ]
                    }}
                />
            </div>
        </ChartBase>
    )
}

export default TrikosPerCity
